<template>
<div :key="ts" :colName="fieldId">
  <div :class="controlClass" ref="ctrl">
    <div class="d-flex">
      <label :for="id" :class="labelClass" @click="setInputFocus" ref="cap"><i :class="bulletClass"></i>{{ label }}</label>
      <div :title="tooltip" v-if="tooltip" class="tooltip bold">
        <i  class="fa fa-question-circle-o mt-2 mr-2"></i>
      </div>
    </div>

    <div :class="selectContainerClass" ref="inpcont">
        <select
          :id="id"
          ref="inputbox"
          :class="inputClass"
          v-model="selected"
          @input="onChange($event.target.value, value)"
          @keydown="onKeyDown($event, value)"
          @focus="onFocus"
          @blur="onBlur"
        >
          <option
            v-for="option in datasource"
            :value="optionValue(option)"
            :key="optionValue(option)">{{ displayText(option) }}
          </option>
        </select>
        

        <button type="button" :class="buttonClass" tabindex=-1><i class="fa fa-fw fa-chevron-down"></i></button>
    </div>

  </div>

</div>

</template>

<script>

import
  InputCore
from './InputCore.vue';

export default {
  extends: InputCore,

  model: {
    prop: 'value',
    event: 'changed',
    tooltip: 'tooltip',   
  },

  props: {
    value: undefined,
    displayField: { type: String, required: true },
    datasource: { type: Array, required: true },
    sourceField: { type: String },
    tooltip: { type: String, default: '' },    
  },

  data () {
    return {
      selected: this.value
    };
  },

  computed: {
    selectContainerClass () {
      return this.inputWidth ? 'px-0 fw-' + this.inputWidth : 'px-0 w-100';
    },

    buttonClass () {
      return this.theme.buttonColor + ' select-button curved-left-0' + (this.align === 'bottom' && !this.isPlain ? ' curved-top-right-0' : '');
    },

    inputClass () {
      const me = this;
      let cls = '';
      if (me.hasCaption) {
        if (me.isPlain) {
          cls = 'curved';
        } else {
          if (me.isAlignBottom) {
            cls = 'curved-top-0';
          } else {
            cls = 'curved-right';
          }
        }
      }
      cls = cls + (me.inputWidth ? ' fw-' + me.inputWidth : ' flex-fill');
      return cls + (me.inputAlign === 'left' ? '' : ' text-' + me.inputAlign) + (me.inputBoxClass ? ' ' + me.inputBoxClass : '');
    },

  },

  methods: {
    onKeyDown (e, value) {
      const
        me = this,
        targetValue = e.target.value;

      e.colName = me.fieldId;
      me.$emit('keydown', e, targetValue, value);
      if (e.defaultPrevented) { return; }
      me.handleKeyDown(e, targetValue, value);
    },

    onChange (newValue, oldValue) {
      const
        me = this,
        item = me.core.getArrayItem(me.datasource, me.fieldId, newValue);

      me.handleChange(me.toInternalValue(newValue), oldValue, item ? item[me.displayField] : '');
    },

    isEmpty () {
      return this.selected ? false : true;
    },

    optionValue (option) {
      const field = this.sourceField || this.fieldId;
      return option[field];
    },

    displayText (option) {
      return option[this.displayField];
    },

    toInternalValue (value) {
      if (this.meta && this.meta.datatype === 'S') {
        return value;
      }
      if (this.core.isInteger(value)) {
        return value / 1;
      }
      return value;
    },

    refresh () {
      this.ts +=1;
    }

  },

  watch: {
    value (val) {
      this.selected = val;
    }
  }

};

</script>

